<template>
  <Treeselect
    v-bind="$attrs"
    multiple
    v-on="$listeners"
  />
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: "AppTreeSelect",
  components: {
    Treeselect
  }
}
</script>